import { createAuth } from '@titularis/api-client';

const baseUrl = import.meta.env.VITE_API_URL ?? 'http://localhost:3333';

export const authClient = createAuth(baseUrl);
export const { useSession, signIn, signUp, signOut } = authClient;
